export default "__VITE_ASSET__4ed4c150__"